import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-lot-carousel-thumbs-actions',
  templateUrl: './lot-carousel-thumbs-actions.component.html',
  styleUrls: ['./lot-carousel-thumbs-actions.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotCarouselThumbsActionsComponent {
  @Input() expanded = false;
  @Input() showExpandButton = false;
  @Input() downloadUrl?: string;

  @Output() toggleExpand = new EventEmitter<void>();
}
